module.exports = __webpack_public_path__ + "img/camera-icon.a9f5eb5f.png";